import { jsx, jsxs } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
import { FontSize } from "../../../foundations/typography.es.js";
import { styled } from "@mui/material";
import { FilePreview } from "./file-icon.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Direction } from "../../../foundations/direction.es.js";
import { Typography } from "../../typography/typography.es.js";
const StyledDropzonePreviewer = styled("div")(({
  theme
}) => ({
  display: Displaying.flex,
  padding: `${theme.spacing(10)} 0px`,
  flexDirection: Direction.row,
  justifyContent: Alignment.center,
  alignItems: Alignment.center,
  gap: theme.spacing(8)
}));
function DropzonePreviewer({
  acceptedFiles
}) {
  return /* @__PURE__ */ jsx(StyledDropzonePreviewer, { "data-testid": "styled-dropzone-previewer", children: acceptedFiles.map((fileWithUrl) => {
    const {
      file,
      url
    } = fileWithUrl;
    return /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx(FilePreview, { fileType: file.type, fileUrl: url, fileName: file.name }),
      /* @__PURE__ */ jsx(Typography, { color: "textSecondary", fontSize: FontSize["xs"], children: file.name })
    ] }, `${file.name}-${file.size}-${file.type}`);
  }) });
}
export {
  DropzonePreviewer
};
//# sourceMappingURL=file-previewer.es.js.map
